import {
  Collapsible,
} from '@equifinance/shared';
import styled, { css } from 'styled-components';
import { Note } from '../../../contexts/tasks';
import { Notes } from './Notes';

const headerCss = css`${({ theme }) => `
  background: ${theme.colours.warning[3]};
  padding: ${theme.padding[1]} ${theme.padding[5]};

  .mi-chevron-down, .mi-chevron-up {
    color: ${theme.colours.neutral[10]};
  }
`}`;

const titleCss = css`${({ theme }) => `
  color: ${theme.colours.neutral[10]};
`}`;

const bodyContentCss = css`${({ theme }) => `
  gap: ${theme.padding[4]};
`}`;

const InternalOnly = styled.p`${({ theme }) => `
  font-size: ${theme.fontSize[1]};
  font-weight: ${theme.fontWeight.normal};
  font-style: italic;
  color: ${theme.colours.neutral[2]};
  padding: 0 ${theme.padding[4]};
`}`;

export default function InternalNotes({ taskId, notes }: { taskId: string, notes: Note[] }) {
  return (
    <Collapsible
      title="Underwriter's Notes"
      level={3}
      headerCss={headerCss}
      titleCss={titleCss}
      bodyContentCss={bodyContentCss}
    >
      <InternalOnly>Internal only</InternalOnly>
      <Notes taskId={taskId} notes={notes ?? []} isExternalNote={false} />
    </Collapsible>
  );
}
